/**
 * CASA custom.js — Variant-Bild-Filter (Sam Moebel)
 * ------------------------------------------------------------
 * Filtert die Produktbilder auf die gerade gewaehlte Variante.
 * Alt-Text-Format aus run2_media.js: "#wert1 #wert2 #wert3"
 * (lowercase, ohne Spaces). Ein Bild bleibt sichtbar, wenn ALLE
 * seine #-Tokens unter den gewaehlten Optionswerten vorkommen.
 *
 * Server-seitiger Erst-Filter sitzt in snippets/product-media.liquid;
 * diese Datei macht das dynamische Re-Filtern bei Variantenwechsel
 * (Focal baut die Flickity-Galerie bei jedem Wechsel neu auf).
 *
 * Groessen-Tokens werden uebersprungen (cm/mm sowie das CASA-Format
 * "200x100" / "220(320)x100"), weil die Groesse bei gesplitteten
 * Produkten ueber die Produktgruppierung laeuft und im Formular
 * ausgeblendet ist.
 */
(function () {
  function injectFilterCSS() {
    if (document.getElementById('sam-filter-style')) return;
    var style = document.createElement('style');
    style.id = 'sam-filter-style';
    style.appendChild(document.createTextNode(
      '.product__media .is-filtered,' +
      '.product__media-list .is-filtered,' +
      '.product__media-item.is-filtered,' +
      '.dots-nav__item.is-filtered,' +
      '.product__thumbnail-item.is-filtered,' +
      '.flickity-slider .is-filtered {' +
        'display: none !important;' +
        'visibility: hidden !important;' +
        'width: 0 !important;' +
        'height: 0 !important;' +
      '}'
    ));
    (document.head || document.documentElement).appendChild(style);
  }

  function getSelectedValuesFromForm(formEl) {
    var values = [];
    if (!formEl) return values;
    var selects = formEl.querySelectorAll('select[name^="options"]');
    for (var i = 0; i < selects.length; i++) values.push(selects[i].value || '');
    var radios = formEl.querySelectorAll('input[name^="options"]:checked');
    for (var j = 0; j < radios.length; j++) values.push(radios[j].value || '');
    return values;
  }

  // true = Bild ausblenden
  function shouldFilterAlt(rawAlt, mediaId, featuredId, selectedValues) {
    if (featuredId && mediaId === featuredId) return false;
    if (!rawAlt || rawAlt.indexOf('#') === -1) return false;
    var parts = rawAlt.replace(/\|/g, ' ').split('#');
    for (var p = 1; p < parts.length; p++) {
      var token = (parts[p] || '').replace(/^\s+|\s+$/g, '').toLowerCase().replace(/\s+/g, '');
      if (token === '') continue;
      // Groessen-Tokens ignorieren: 180cm/76mm UND CASA-Format 200x100 / 220(320)x100
      if (/\d+(\.\d+)?(cm|mm)$/.test(token)) continue;
      if (/^\d+(\(\d+\))?x\d+$/.test(token)) continue;
      if (selectedValues.indexOf(token) === -1) return true;
    }
    return false;
  }

  function reapplyClassFilter(formEl, variant, phaseTag) {
    var formId = formEl ? formEl.getAttribute('id') : null;
    if (!formId) return;
    var media = document.querySelector('product-media[form-id="' + formId + '"]');
    if (!media) return;

    var rawValues = (variant && Object.prototype.toString.call(variant.options) === '[object Array]')
                      ? variant.options.slice() : [];
    if (rawValues.length === 0) rawValues = getSelectedValuesFromForm(formEl);
    if (rawValues.length === 0) return;
    var selectedValues = [];
    for (var rv = 0; rv < rawValues.length; rv++) {
      selectedValues.push(String(rawValues[rv] == null ? '' : rawValues[rv]).toLowerCase().replace(/\s+/g, ''));
    }

    var featuredId = null;
    if (variant) {
      if (variant.featured_media && variant.featured_media.id) featuredId = String(variant.featured_media.id);
      else if (variant.featured_media_id) featuredId = String(variant.featured_media_id);
    }

    var allItems = media.querySelectorAll('[data-original-alt]');
    if (allItems.length === 0) return;

    var hidden = 0, visible = 0;
    for (var i = 0; i < allItems.length; i++) {
      var el = allItems[i];
      var sf = shouldFilterAlt(
        el.getAttribute('data-original-alt') || '',
        el.getAttribute('data-media-id') || '',
        featuredId,
        selectedValues
      );
      if (sf) {
        if (!el.classList.contains('is-filtered')) el.classList.add('is-filtered');
        hidden++;
      } else {
        if (el.classList.contains('is-filtered')) el.classList.remove('is-filtered');
        visible++;
      }
    }

    // Safety-Net: wuerde ALLES gefiltert -> nichts ausblenden
    if (visible === 0) {
      for (var r = 0; r < allItems.length; r++) allItems[r].classList.remove('is-filtered');
    }
  }

  function findFormEl(event) {
    if (event.target && event.target.tagName === 'FORM') return event.target;
    if (event.target && event.target.closest) {
      var f = event.target.closest('form[id^="product-form"]');
      if (f) return f;
    }
    return document.querySelector('form[id^="product-form"]');
  }

  // Debounce: EIN Anker + EIN Timer pro Variantenwechsel
  var scrollAnchor = null;
  var activeTimer  = null;

  function handler(event) {
    var formEl = findFormEl(event);
    var variant = event.detail && event.detail.variant;

    if (scrollAnchor === null) {
      scrollAnchor = window.scrollY || window.pageYOffset || 0;
    }

    // sofort - vor Focals naechstem _createFlickity
    reapplyClassFilter(formEl, variant, 'SYNC');

    // spaet debounced - nur der letzte Timer laeuft durch
    if (activeTimer) clearTimeout(activeTimer);
    activeTimer = setTimeout(function () {
      reapplyClassFilter(formEl, variant, 'LATE');
      var scrollAfter = window.scrollY || window.pageYOffset || 0;
      var drift = scrollAfter - scrollAnchor;
      if (Math.abs(drift) > 50) {
        try { window.scrollTo({ top: scrollAnchor, behavior: 'instant' }); }
        catch (e) { window.scrollTo(0, scrollAnchor); }
      }
      scrollAnchor = null;
      activeTimer  = null;
    }, 350);
  }

  injectFilterCSS();
  document.addEventListener('variant:changed', handler);
  document.addEventListener('variant:change',  handler);
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name && e.target.name.indexOf('options') === 0) handler(e);
  });
})();
